import { IInputProps } from 'modules';
import React, { TextareaHTMLAttributes } from 'react';

export const InputTextArea = (
  props: IInputProps & TextareaHTMLAttributes<HTMLTextAreaElement>,
) => {
  const {
    value,
    onChange,
    onTouched,
    onChangeCallback,
    isDisabled,
    isReadOnly,
    isMutilLocale,
    locales,
    getValue,
    error,
    description,
    label,
    isRequired,
    defaultValue,
    ...rest
  } = props;
  return (
    <textarea
      {...rest}
      onChange={(e) => {
        if (isDisabled) return;
        onChange(e.target.value);
        onChangeCallback?.(e.target.value);
      }}
      onBlur={() => setTimeout(() => onTouched && onTouched(), 500)}
      value={value || ''}
      readOnly={isReadOnly}
      disabled={isDisabled || isReadOnly}
    />
  );
};
